export default __webpack_public_path__ + "static/solutionCardLeft-ac68ce7a916d0e0e35bbe55f1cca6a7b.png";